import { createApp, h } from 'vue'
import { convertDataSet } from './helper'

import Main from '../components/Quiz/Main.vue'

if(document.getElementById("quizComponent")){
    const app1 = createApp({
        render() {
            return h(Main, convertDataSet('quizComponent'))
        }
    })

    app1.mount('#quizComponent')
}